import React, { Component } from 'react';

export class NotificationBoxPreview extends Component {
  render() {
    return (
      <>
        {
          this.props.notificationTitle ?
            <div
              className="notificationbox-preview"
              style={{background: this.props.boxColor}}
            >
              <div className="row">
                {
                  this.props.notificationImage ?
                    this.props.notificationImage !== 0 ?
                      <div className="col-3">
                        <img src={this.props.notificationImage} className="img-responsive"/>
                      </div>
                    : null
                  : null
                }

                <div className={this.props.notificationImage && this.props.notificationImage.length !== 0 ? 'col-9' : 'col-12'}>
                  <p
                    className="notificationbox-title"
                    style={
                      this.props.notificationImage && this.props.notificationImage.length !== 0 ?
                        {marginLeft: "-15px", color: this.props.titleColor}
                      : {marginLeft: "0", color: this.props.titleColor}
                    }
                  >
                    {this.props.notificationTitle}
                  </p>
                  <p
                    className="notificationbox-content"
                    style={
                      this.props.notificationImage && this.props.notificationImage.length !== 0 ?
                        {marginLeft: "-15px", color: this.props.descriptionColor}
                      : {marginLeft: "0", color: this.props.descriptionColor}
                    }
                  >
                    {this.props.notificationContent}
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="buttons">
                    <a
                      href={null}
                      type="button"
                      className="text-only"
                      style={{
                        color: this.props.btnBackground
                      }}
                    >
                      FECHAR
                    </a>
                    {
                      this.props.notificationButtonText ?
                        <a
                          href={this.props.notificationButtonUrl}
                          type="button"
                          target="_blank"
                          style={{
                            background: this.props.btnBackground,
                            color: this.props.btnColor
                          }}
                        >
                          {this.props.notificationButtonText}
                        </a>
                      : null
                    }
                  </div>
                </div>
              </div>
            </div>
          : null
        }
      </>
    )
  }
}

export class AlertPreview extends Component {
  render() {
    const alertPosition = () => {
      switch ( this.props.alertPosition ) {
        case 'topLeft': return {background: this.props.alertBackgroundColor, top: "15px", left: "15px", transform: "translate(0, 0)"}; break;
        case 'topCenter': return {background: this.props.alertBackgroundColor, top: "15px", left: "50%", transform: "translate(-50%, 0)"}; break;
        case 'topRight': return {background: this.props.alertBackgroundColor, top: "15px", right: "15px", transform: "translate(0, 0)"}; break;
        case 'centerLeft': return {background: this.props.alertBackgroundColor, top: "50%", left: "15px", transform: "translate(0, -50%)"}; break;
        case 'centerCenter': return {background: this.props.alertBackgroundColor, top: "50%", left: "50%", transform: "translate(-50%, -50%)"}; break;
        case 'centerRight': return {background: this.props.alertBackgroundColor, top: "50%", right: "15px", transform: "translate(0, -50%)"}; break;
        case 'bottomLeft': return {background: this.props.alertBackgroundColor, bottom: "15px", left: "15px", transform: "translate(0, 0)"}; break;
        case 'bottomCenter': return {background: this.props.alertBackgroundColor, bottom: "15px", left: "50%", transform: "translate(-50%, 0)"}; break;
        case 'bottomRight': return {background: this.props.alertBackgroundColor, bottom: "15px", right: "15px", transform: "translate(0, 0)"}; break;
        default: break;
      }
    }

    return (
      <>
        {
          this.props.alertContent ?
            <div
              className="alert-preview"
              style={alertPosition()}
            >
              <p className="alert-content" style={{color: this.props.alertContentColor}}>{this.props.alertContent}</p>
              <button type="button" style={{color: this.props.alertContentColor}}><i className="linearicons-cross"></i></button>
            </div>
          : null
        }
      </>
    )
  }
}

export class TopbarPreview extends Component {
  render() {
    return (
      <>
        {
          this.props.topbarContent ?
            <div className="topbar-preview" style={{background: this.props.topbarBackgroundColor}}>
              <div className="row">
                <div className="col-9">
                  <p className="topbar-content" style={{color: this.props.topbarContentColor}}>{this.props.topbarContent}</p>
                </div>
                <div className="col-3 to-right">
                  <a href={this.props.topbarBtnUrl} target="_blank" className="float-right" style={{color: this.props.topbarBtnColor, background: this.props.topbarBtnBackground}}>{this.props.topbarBtnText}</a>
                </div>
              </div>

              <button type="button" className="topbar-close" style={{color: this.props.topbarContentColor}}><i className="linearicons-cross"></i></button>
            </div>
          : null
        }
      </>
    )
  }
}